import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import api from '../../axiosConfig';
import LimitSheets from './LimitSheets';
import SimausMaterials from './SimausMaterials';
import { authFetch } from './authFetch';
import { recipeMaterials } from './orderMaterialRows';


export default function OrderMaterials({ order, pendingChanges, saving, onChanged, onCloseOrder, closing }) {
  const [state, setState] = useState({ product: null, recipe: null, busy: false, error: '' });
  const [revision, setRevision] = useState(0);
  const product = order.bxpart_id;
  const closed = !!(order.bxdatafin || order.factura_id || order.bxdata_factura);
  useEffect(() => {
    let active = true;
    setState({ product, recipe: null, busy: !!product, error: '' });
    if (product) api.get(`/bxreteta/activa/${product}`).then(({ data }) => {
      if (active) setState({ product, recipe: data, busy: false, error: '' });
    }).catch(error => {
      if (active) setState({ product, recipe: null, busy: false,
        error: error.response?.status === 404 ? '' : 'Rețeta nu a putut fi încărcată. Încercați din nou.' });
    });
    return () => { active = false; };
  }, [product, revision]);
  const current = state.product === product;
  const preview = current ? recipeMaterials(state.recipe, order.bxcantitate) : [];
  const reloadOrder = async () => {
    const fresh = await authFetch(`/comenzi/interna/${order.bxid}`);
    if (onChanged) onChanged(fresh);
  };
  return <div className="mt-3">
    <Alert variant="info">1. Fișa-limită unică se completează automat din rețetă. Puteți elimina linii nefolosite sau adăuga materiale fără rețetă. 2. Rezervați barele din gestiunea 4.
      3. Confirmați predarea în 3.NETERM. 4. Returnați resturile. 5. Închideți comanda pentru consum și nota contabilă.
      Salvarea comenzii sau a necesarului nu transferă stocul.</Alert>
    <h5>Rețeta produsului — necesar orientativ</h5>
    {!product && <p>Alegeți produsul în General pentru a vedea rețeta.</p>}
    {product && (!current || state.busy) && <p role="status">Se încarcă rețeta produsului…</p>}
    {current && state.error && <Alert variant="warning">{state.error} <Button size="sm" onClick={() => setRevision(v => v + 1)}>Reîncearcă</Button></Alert>}
    {product && current && !state.busy && !state.error && !preview.length && <p>Produsul nu are o rețetă activă cu materiale. Adăugați necesarul suplimentar în fișa-limită.</p>}
    {!order.bxid && <Alert variant="info">Salvați comanda înainte de pregătirea materialelor.</Alert>}
    {pendingChanges && <Alert variant="warning">Salvați modificările comenzii înainte de operațiile pe fișa-limită.</Alert>}
    {order.bxid && <LimitSheets orderId={order.bxid} locked={!!pendingChanges || !!saving} orderClosed={closed}
      automatic={!order.reteta?.length} recipeRows={preview} onChanged={reloadOrder}/>}
    {!!order.reteta?.length && <details className="my-3"><summary>Materiale din fluxul anterior</summary>
      <p>Mișcările existente se păstrează. Comenzile cu transferuri din fluxul anterior nu se combină cu fișe-limită noi.</p>
      <SimausMaterials gridMode scope="all" orderId={order.bxid} closed={closed} pendingChanges={pendingChanges}/>
    </details>}
    {order.bxid && <Button className="my-3" disabled={closed || pendingChanges || saving || closing} onClick={onCloseOrder}>
      {closing ? 'Se închide…' : 'Închide comanda și consumă materialul folosit'}</Button>}
  </div>;
}
